// extracted by mini-css-extract-plugin
export default {"businessCard":"Card_businessCard__kln7a","imgStyle":"Card_imgStyle__ZVyDz"};